import { useEffect, useState } from 'react';
import { useSystem } from './useUserInfo';
import { decryptByDESModeCBC } from '@/utils/crypto';

export const useMap = () => {
  const { systemData } = useSystem();
  const [isInitialled, setIsInitialled] = useState<boolean>(false);
  const [mapKey, setMapKey] = useState<string>('');
  useEffect(() => {
    // 获取高德地图 Key
    const key = systemData?.amap?.Key || '';
    setMapKey(key);

    // 如果有 Key 就允许初始化地图（Key 是必需的，SecurityCode 可选）
    if (key) {
      // 尝试配置安全密钥（可选）
      if (systemData?.amap?.Secret) {
        const securityJsCode = decryptByDESModeCBC(systemData?.amap?.Secret || '') || '';
        if (securityJsCode) {
          // @ts-ignore
          window._AMapSecurityConfig = {
            securityJsCode,
          };
        }
      }
      // 有 Key 即可初始化
      setIsInitialled(true);
    }
  }, [systemData]);
  return { isInitialled, mapKey };
};
